import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

// Surfaces any ATS account-verification the automation is paused on (e.g. Workday emails a
// code during account creation). Dormant until the engine (Track B/B3) creates a pending
// record; polls so a code request appears without a manual refresh.
export default function VerificationBanner() {
  const [pending, setPending] = useState([]);
  const [codes, setCodes] = useState({});
  const [busy, setBusy] = useState(null);

  const load = () =>
    api.get("/apply/verifications").then(({ data }) => setPending(data.pending || [])).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const nameOf = (v) => (v.tenant ? v.tenant.charAt(0).toUpperCase() + v.tenant.slice(1) : (v.ats || "the employer"));

  const submit = async (v) => {
    const code = (codes[v.verification_id] || "").trim();
    if (!code) return;
    setBusy(v.verification_id);
    try {
      await api.post(`/apply/verifications/${v.verification_id}/code`, { code });
      toast.success("Code submitted — your application will continue");
      setPending((p) => p.filter((x) => x.verification_id !== v.verification_id));
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not submit code");
    } finally {
      setBusy(null);
    }
  };

  if (pending.length === 0) return null;

  return (
    <div className="space-y-3 mb-6">
      {pending.map((v) => (
        <div key={v.verification_id} className="rounded-2xl border border-[#F59E0B]/40 bg-[#F59E0B]/5 px-4 py-3.5">
          <div className="flex items-start gap-3">
            <KeyRound className="w-4 h-4 text-[#B45309] flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-[#0F172A]">
                Verification needed to continue your {nameOf(v)} application
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                Check {v.email || "your email"} for a code from {nameOf(v)}, then enter it here.
              </p>
              <div className="flex items-center gap-2 mt-2.5">
                <input
                  value={codes[v.verification_id] || ""}
                  onChange={(e) => setCodes((c) => ({ ...c, [v.verification_id]: e.target.value }))}
                  onKeyDown={(e) => { if (e.key === "Enter") submit(v); }}
                  placeholder="Enter code"
                  inputMode="numeric"
                  className="w-40 px-3 py-1.5 text-sm rounded-lg border border-border focus:outline-none focus:border-[#0025D8]"
                />
                <button
                  onClick={() => submit(v)}
                  disabled={busy === v.verification_id || !(codes[v.verification_id] || "").trim()}
                  className="px-4 py-1.5 text-sm font-semibold rounded-lg bg-[#0025D8] text-white hover:bg-[#001CB3] transition-colors disabled:opacity-50"
                >
                  {busy === v.verification_id ? "Submitting…" : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
